import { useState } from "react";
import { chatSupportUrl } from "../utils/config";
import Loader from './Loader';

function ChatSupport() {
    const [isLoaded, setIsLoaded] = useState(false);

    return (
        <div className="w-full h-screen flex flex-col">
            {!isLoaded && (
                <Loader />
            )}
            <div className={`flex-1 ${isLoaded ? "block" : "hidden"}`}>
                <iframe
                    src={chatSupportUrl}
                    className="w-full h-full"
                    allow="microphone; camera"
                    style={{ border: 'none' }}
                    title="Tawk.to Live Chat"
                    onLoad={() => setIsLoaded(true)}
                ></iframe>
            </div>
        </div>
    );
}

export default ChatSupport;
